import React from "react";
import track from "react-tracking";

import { Box } from "@metrea-ui/v2";
import { PageHeader } from "../components/SiteLayout/Header";
import { PageFooter } from "../components/SiteLayout/Footer";

const About_Page = () => {
	return (
		<>
			<PageHeader pageTitle="About Page" />
			<Box className="pageContent">
				<h4>More to come...</h4>
				<PageFooter />
			</Box>
		</>
	);
};

export const About = track(
	{ page: "About" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) }
)(About_Page);
